import { ApiConfig } from '../../Config.js';
import axios from 'axios';

var SetCellNumberLoginCtrl = function (fn, er, state, telephone, token, ids) {

    var config = {
        //crossDomain: true,
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json',
            'MT_SESSION_ID': ids
        },
    };

    var data = {

        cellNumber: telephone

    };

    axios
        .post(ApiConfig.url.SET_TEL_LOGIN, data, config)
        .then(function (result) {
            fn(result.data, result.status)
        })
        .catch(function (error) {
            er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
        });
}

export { SetCellNumberLoginCtrl };